import { IoMdStar } from 'react-icons/io'

interface RatingProps {
  value: number
  showStar?: boolean
}

export function Rating({ value, showStar = true }: RatingProps) {
  return (
    <div className="flex items-center gap-1">
      {showStar && <IoMdStar className="w-3 h-3 text-yellow-400" />}
      <span className="text-xs text-gray-900">{value.toFixed(2)}</span>
    </div>
  )
}
